import { render, staticRenderFns } from "./email-settings-tab.vue?vue&type=template&id=3ce92c93"
import script from "./email-settings-tab.vue?vue&type=script&lang=ts"
export * from "./email-settings-tab.vue?vue&type=script&lang=ts"
import style0 from "./email-settings-tab.vue?vue&type=style&index=0&id=3ce92c93&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce92c93')) {
      api.createRecord('3ce92c93', component.options)
    } else {
      api.reload('3ce92c93', component.options)
    }
    module.hot.accept("./email-settings-tab.vue?vue&type=template&id=3ce92c93", function () {
      api.rerender('3ce92c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/email-settings-tab/email-settings-tab.vue"
export default component.exports